import { Helmet } from "react-helmet-async";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import { FaArrowRight } from "react-icons/fa6";
import { GrLocation } from "react-icons/gr";
import { MdOutlineCalendarToday } from "react-icons/md";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { Link } from "react-router-dom";

const UpcomingEvents = () => {
  return (
    <section className="w-full bg-cover h-fit pb-5">
      <Helmet>
        <title>Upcoming events</title>
        <meta
          name="description"
          content="Learn more about MIJSC, our mission, vision, and commitment to excellence."
        />
      </Helmet>
      <BreadCrumbs />
      <section className="up-coming-events md:mx-10 mx-5 mb-10">
        <div className="flex justify-between">
          <div className="text-left">
            <h1 className="md:text-4xl text-lg mt-5 text-green-600 font-semibold uppercase text-left">
              Upcoming Events
            </h1>

            <p className="pb-5 mb-5 mt-2">
              Join us for our upcoming programs and workshops
            </p>
          </div>
        </div>

        <div className="w-full h-fit md:flex gap-6 mt-10">
          <div className="mt-4 md:mt-0 shadow-sm md:w-[50%] w-[100%] pb-2 pt-5 flex bg-green-50 rounded-lg border border-green-200">
            <div className="w-fit h-fit pb-3 bg-white rounded-lg mx-4 shadow-2xl px-5">
              <p className="font-bold text-xs text-green-600 my-3"> Aug </p>
              <p className="font-bold text-3xl my-3"> 09 </p>
              <p className="text-slate-700 text-xs my-3"> 2026 </p>
            </div>
            <div className=" w-[22rem] h-fit pb-1 rounded-b-lg  text-left mx-3">
              <h3 className="text-2xl mb-4 font-bold">Graduation Ceremony</h3>
              <div className="w-full mt-2 justify-center gap-10">
                <div className="py-2 px-3 bg-[#05976a] text-white md:w-52 w-full rounded-full text-sm">
                  LMP Batch 4
                </div>
              </div>
              <div className="flex mb-4 gap-1 mt-3 items-center">
                <GrLocation className="text-green-600" />
                <p className="text-slate-700 text-sm">
                  Graduation Ceremony at IIMB
                </p>
              </div>
              <div className="flex gap-1 items-center mb-4">
                <MdOutlineCalendarToday className="text-green-600" />
                <p className="text-slate-700 text-sm">August 09, 2026</p>
              </div>
            </div>
          </div>
          <div className="mt-4 md:mt-0 shadow-sm md:w-[50%] w-[100%] pb-2 pt-5 flex bg-green-50 rounded-lg border border-green-200">
            <div className="w-fit h-fit pb-3 bg-white rounded-lg mx-4 shadow-2xl px-5">
              <p className="font-bold text-xs pt-2 text-green-600 my-3">
                {" "}
                Aug{" "}
              </p>
              <p className="font-bold text-3xl my-3"> 7-9 </p>
              <p className="text-slate-700 text-xs my-3 "> 2026 </p>
            </div>
            <div className=" w-[22rem] h-fit pb-1 rounded-b-lg  text-left mx-3">
              <h3 className="text-2xl mb-4 font-bold">LMP Conclave </h3>
              <div className="w-full mt-2 justify-center gap-10">
                <div className="px-3 bg-[#05976a] text-white py-2 md:w-44 w-full rounded-full text-xs">
                  LMP Batch 5
                </div>
              </div>
              <div className="flex mb-4 gap-1 mt-3 items-center">
                <GrLocation className="text-green-600" />
                <p className="text-slate-700 text-sm">LMP Conclave at IIMB</p>
              </div>
              <div className="flex gap-1 items-center mb-4">
                <MdOutlineCalendarToday className="text-green-600" />
                <p className="text-slate-700 text-sm ">August 7,8,9, 2026 </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default UpcomingEvents;
